import { defineMessages } from 'react-intl';

const _default_1: {
	closeMenu: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	hubLogo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	login: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	openMenu: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	hubLogo: {
		id: 'company-hub.hub-app-shell.navbar.hub.logo',
		defaultMessage: 'Support home',
		description:
			'The accessible label for the Hub logo link in the navigation bar, which navigates to the support home page when clicked.',
	},
	login: {
		id: 'company-hub.hub-app-shell.navbar.hub.log-in',
		defaultMessage: 'Log in',
		description:
			'The text is shown on a button in the navigation bar that allows unauthenticated users to sign in to the help center.',
	},
	openMenu: {
		id: 'company-hub.hub-app-shell.navbar.open-menu.non-final',
		defaultMessage: 'Open navigation menu',
		description:
			'The accessible label for the hamburger button in the navigation bar that opens the mobile navigation menu.',
	},
	closeMenu: {
		id: 'company-hub.hub-app-shell.navbar.close-menu.non-final',
		defaultMessage: 'Close navigation menu',
		description:
			'The accessible label for the close button in the mobile navigation menu overlay that dismisses it.',
	},
});
export default _default_1;
